<template>
  <div>
    <div v-for="month in sortedMonths" :key="month.order" class="month-selector">
      <label class="checkbox">
        <input type="checkbox" name="months_selector"
               :value="month.number"
               :checked="monthIsChecked(month)"
               @click="toggleSelectedMonth(month)"
        >
        <div>{{ month.short }}</div>
      </label>
    </div>
  </div>
</template>

<style lang="scss">
  .month-selector {
    display: inline-block;
    width: 55px;
    height: 40px;
    user-select: none;

    label.checkbox {
      input {
        display: block;
      }

      font-weight: normal;
    }
  }
</style>

<script>
export default {
  name: 'ProductMonthSelector',
  props: ['startingMonths'],
  data() {
    return {
      months: [
        { order: 1, number: 9, name: 'September', short: 'Sep' },
        { order: 2, number: 10, name: 'October', short: 'Oct' },
        { order: 3, number: 11, name: 'November', short: 'Nov' },
        { order: 4, number: 12, name: 'December', short: 'Dec' },
        { order: 5, number: 1, name: 'January', short: 'Jan' },
        { order: 6, number: 2, name: 'February', short: 'Feb' },
        { order: 7, number: 3, name: 'March', short: 'Mar' },
        { order: 8, number: 4, name: 'April', short: 'Apr' },
        { order: 9, number: 5, name: 'May', short: 'May' },
        { order: 10, number: 6, name: 'June', short: 'Jun' },
        { order: 11, number: 7, name: 'July', short: 'Jul' },
        { order: 12, number: 8, name: 'August', short: 'Aug' },
      ],
      selectedMonths: []
    }
  },
  computed: {
    sortedMonths() {
      return this.months.sort((a, b) => {
        return a.order - b.order
      })
    }
  },
  methods: {
    monthIsChecked(month) {
      return this.selectedMonths.indexOf(month.number) !== -1
    },
    toggleSelectedMonth(month) {
      let selectedMonths     = this.selectedMonths;
      let selectedMonthIndex = this.selectedMonths.indexOf(month.number);
      if (selectedMonthIndex !== -1) {
        selectedMonths.splice(selectedMonthIndex, 1);
      }
      else {
        selectedMonths.push(month.number);
      }

      this.selectedMonths = selectedMonths.sort((a, b) => {
        let aMonth = this.months.find(month => month.number === a)
        let bMonth = this.months.find(month => month.number === b)
        return aMonth.order - bMonth.order
      })

      this.$emit('monthsChanged', this.selectedMonths)
    }
  },
  mounted() {
    this.selectedMonths = this.startingMonths
  }
}
</script>



// WEBPACK FOOTER //
// ProductMonthSelector.vue?686c2eee